import _ from 'lodash';
// =======================================================================================================
export interface RamStorageInfo {
    Storage: { [key: string]: any },
    Timestamp: { [key: string]: any },
}
// =======================================================================================================
export class RamStorage {
    // --------------------------------------------------------------------------------------------
    public static GetInstance(): RamStorage {
        let state = (window as any).__RAM_STORAGE__;
        if (state == undefined) {
            state = new RamStorage();
            (window as any).__RAM_STORAGE__ = state;
        }
        return state;
    };
    // --------------------------------------------------------------------------------------------
    private state: RamStorageInfo;
    // --------------------------------------------------------------------------------------------
    constructor() {
        this.state = {
            Storage: {},
            Timestamp: {}
        };
    }
    // --------------------------------------------------------------------------------------------
    public GetState(key: string): any | null {
        if (_.has(this.state.Storage, key))
            return this.state.Storage[key];
        return null;
    }
    // --------------------------------------------------------------------------------------------
    public GetStateWithTimestamp(key: string): { data: any, timestamp: number } | null {
        if (_.has(this.state.Storage, key))
            return { data: this.state.Storage[key], timestamp: this.state.Timestamp[key] };
        return null;
    }
    // --------------------------------------------------------------------------------------------
    public SetState(key: string, data: any) {
        this.state.Storage[key] = data;
        this.state.Timestamp[key] = Date.now();
    }
    // --------------------------------------------------------------------------------------------
    public RemoveState(key: string) {
        if (_.has(this.state.Storage, key)) {
            this.state.Storage[key] = undefined;
            this.state.Timestamp[key] = undefined;
        }
    }
    // --------------------------------------------------------------------------------------------
    public ClearAll() {
        this.state.Storage = {};
        this.state.Timestamp = {};
    }
    // --------------------------------------------------------------------------------------------
}